// usageLocationAction.js
export const FETCH_USAGE_LOCATIONS_REQUEST = "FETCH_USAGE_LOCATIONS_REQUEST";
export const FETCH_USAGE_LOCATIONS_SUCCESS = "FETCH_USAGE_LOCATIONS_SUCCESS";
export const FETCH_USAGE_LOCATIONS_FAILURE = "FETCH_USAGE_LOCATIONS_FAILURE";

// Synchronous action creators
export const fetchUsageLocationsRequest = () => ({
  type: FETCH_USAGE_LOCATIONS_REQUEST
});

export const fetchUsageLocationsSuccess = (data) => ({
  type: FETCH_USAGE_LOCATIONS_SUCCESS,
  payload: data
});

export const fetchUsageLocationsFailure = (error) => ({
  type: FETCH_USAGE_LOCATIONS_FAILURE,
  payload: error
});